// 6309
export const moduleName = 'permissionManager';

export enum TabName {
  VIEW = 'VIEW',
  ASSIGNEES = 'ASSIGNEES',
  ROLES = 'ROLES',
}

export enum PanelTitle {
  ACTIVITY = 'activity',
  ADVANCEMENT = 'advancement',
  ADVANCEMENT_YOUTH = 'advancement (Youth)',
  CALENDAR = 'calendar',
  CALENDAR_YOUTH = 'calendar (Youth)',
  FINANCE = 'finance',
  LEADERSHIP = 'leadership',
  MEMBERSHIP = 'membership',
  MESSAGING = 'messaging',
  MESSAGING_YOUTH = 'messaging (Youth)',
  UNIT = 'unit',
}

export enum CelKey {
  ACTIVITY_CREATE = 'activityCreate',
  ADVANCEMENT_AWARD = 'advancementAward',
  ADVANCEMENT_APROVE = 'advancementApprove',
  ADVANCEMENT_EDIT = 'advancementEdit',
  ADVANCEMENT_MBLIST = 'advancementMbList',
  ADVANCEMENT_SCOUT_EDITOR = 'advancementScoutEditor',
  ADVANCEMENT_TENDERFOOT_EDITOR = 'advancementTenderfootEditor',
  ADVANCEMENT_SECONDCLASS_EDITOR = 'advancementSecondClassEditor',
  ADVANCEMENT_FIRSTCLASS_EDITOR = 'advancementFirstClassEditorEditor',
  CALENDAR_CREATE = 'calendarCreate',
  SUB_CALENDAR_CREATE = 'subCalendarCreate',
  FINANCE_CREATE = 'financeCreate',
  FINANCE_INDIVCREATE = 'financeIndivCreate',
  FINANCE_POCREATE = 'financePoCreate',
  LEADERSHIP_EDIT = 'leadershipEdit',
  LEADERSHIP_EDIT_RESTRICTED = 'leadershipEditRestricted',
  MEMBERSHIP_INACTIVE_YOUTH = 'membershipInactiveYouth',
  MEMBERSHIP_INACTIVE_ADULT = 'membershipInactiveAdult',
  MESSAGING_CREATE = 'messagingCreate',
  MESSAGING_GROPU_CREATE = 'messagingGroupCreate',
  UNIT_PROFILE_EDIT = 'unitProfileEdit',
  UNIT_EDIT = 'unitEdit',
  UNIT_REPORTS = 'unitReports',
  SUBUNIT_CREATE = 'subUnitCreate',
  SUBUNIT_EDIT = 'subUnitEdit',
  SUBUNIT_DENCHIEF_ADD = 'subUnitDenchiefAdd',
}

export enum Positions {
  //key 3 positions-----------
  CM = 'Cubmaster',
  CR = 'Chartered Organization Rep.',
  CC = 'Committee Chair',
  SM = 'Scoutmaster',
  CUR = 'Council Unit Representative',
  VCA = 'Venturing Crew Advisor',
  SK = 'Skipper',
  PCC = 'Post Committee Chair',
  EPA = 'Explorer Post Advisor',
  ES = 'Exploring Sponsor',
  AS = 'Associate Sponsor',
  //-----------------------------
  MC = 'Committee Member',
  NM = 'New Member Coordinator',
  PT = 'Pack Trainer',
  K3D = 'Key 3 Delegate',
  CORD = 'COR/CUR Delegate',
  US = 'Unit Support',
  SUS = 'Sub-Unit Support',
  DS = 'Den Support',
  DL = 'Den Leader',
  AWL = 'Assistant Webelos Leader',
  LG = 'Lion Guide',
  TDL = 'Tiger Den Leader',
  WL = 'Webelos Leader',
  LAP = 'Lion Adult Partner',
  TCA = 'Tiger Cub Adult',
  EO = 'Executive Officer',
  ADL = 'Asst. Den Leader',
  UT = 'Unit Treasurer',
  ACRUD = 'Activity Approver/Creator/Remover/Editor',
  AAW = 'Advancement Awarder',
  AAPR = 'Advancement Approver',
  AE = 'Advancement Editor (includes Youth Leadership)',
  MBCL = 'MBC List',
  TRE = 'Tenderfoot Requirement Editor/Approver (NO SM NO BOR)',
  SCRR = 'Second Class Requirement Editor/Approver (NO SM NO BOR)',
  FCR = 'First Class Requirement Editor/Approver (NO SM NO BOR)',
  CE = 'Calendar Editor',
  CES = 'Calendar Editor by SubUnit',
  POC = 'P.O. Creator/Editor',
  CMSSG = 'Create Messages',
  MGCRUD = 'Create/Delete/Edit Message Groups',
  PE = 'Profile Editor',

  // old SB positions (Some might not be the correct name)
  ASM = 'Assistant Scoutmaster',
  OUA = 'Online Unit Administrator',
  CS = 'Committee Secretary',
  UOAC = 'Unit Outdoors / Activities Chair',
  UAC = 'Unit Advancement Chair',
  UC = 'Unit Chaplain',
  UTC = 'Unit Training Chair',
  CEC = 'Committee Equipment Coordinator',
  CMC = 'Committee Membership Coordinator',
  YPC = 'Youth Protection Champion',
  USE = 'Unit Secretary',
  SPD = 'ScoutParent (discontinued in 2013)',
  OG = 'Online Guest',
  MBC = 'Merit Badge Counselor',
  AC = 'Assistant Cubmaster',
  WDL = 'Webelos Den Leader',
  WADL = 'Webelos Assistant Den Leader',
  TAP = 'Tiger Adult Partner',
  VSC = 'Varsity Scout Coach',
  AVC = 'Assistant Varsity Coach',
  VCAA = 'Venturing Crew Assoc. Advisor',
  MA = 'Mate',
  PC = 'Parent Coordinator',
  L1YOS = 'Leader of 11-year old Scouts (LDS Troop)',
  CCH = 'Committee Chairman', // Same as Committee Chair?
  UREC = 'Unit Religious Emblems Coord',
  UCSR = 'Unit College Scouter Reserve',
  USR = 'Unit Scouter Reserve',
  LCSFC = 'Lone Cub Scout friend and counselor',
  LSFC = 'Lone Scout friend and counselor',
  UCO = 'Unit Commissioner',
  DC = 'District Commissioner',
  ADC = 'Assistant District Commissioner',
  ACC = 'Assistant Council Commissioner',
  CCO = 'Council Commissioner',
  RC = 'Roundtable Commissioner',
  RS = 'Roundtable Staff',
  NC = 'National Commissioner',
  NCSS = 'National Commissioner Support Staff',
  NCSC = 'National Commissioner Service Chairman',
  ACO = 'Area Commissioner',
  RCO = 'Regional Commissioner',
  VSHC = 'Varsity Scout Huddle Commissioner',
  VSHS = 'Varsity Scout Huddle Staff',
  DCM = 'District Committee Member',
  DCH = 'District Chairman',
  DVC = 'District Vice Chairman',
  FM = 'Family Member',
  AL = 'Adult Leader',
  CP = 'Council President',
  CVP = 'Council Vice President',
  CT = 'Council Treasurer',
  CAT = 'Council Assistant Treasurer',
  CEBM = 'Council Executive Board Member',
  CAC = 'Council Advisory Council',
  CCM = 'Council Committee Member',
  CML = 'Council Member at Large',
  NCH = 'Neighborhood Chairman',
  NCO = 'Neighborhood Committee',
  DML = 'District Member at Large',
  NAC = 'Nova Awards Counselor',
  SAM = 'Supernova Awards Mentor',
  TA = 'Team Admin',
  SME = 'Squad Member',
  UPRC = 'Unit Public Relations Chair',
  UFC = 'Unit FOS Chair',
  UFRC = 'Unit Fund-Raising Chair',
  USC = 'Unit STEM Coordinator',
  LEC = 'Life-to-Eagle Coordinator',
  RP = 'Regional President',
  RD = 'Regional Director',
  SA = 'Staff Advisor',
  REVP = 'Regional Executive Vice President',
  RVPCOS = 'Regional Vice President - Council Operations Support',
  RPICC = 'Regional Program Impact Committee Chairman',
  RMICC = 'Regional Membership Impact Committee Chairman',
  RMICCH = 'Regional Mission Impact Committee Chairman',
  RFICC = 'Regional Finance Impact Committee Chairman',
  RVPOA = 'Regional Vice President - Outdoor Adventures',
  ROPCC = 'Regional Outdoor Programs Committee Chairman',
  ROAC = 'Regional Order of the Arrow Chairman',
  RJC = 'Regional Jamboree Chair',
  RVPM = 'Regional Vice President - Marketing',
  RVPLL = 'Regional Vice President - Learning for Life',
  EC = 'Exploring Chairman',
  RNCC = 'Regional Nominating Committee Chairman',
  RMSCC = 'Regional Membership Standards Committee Chairman',
  TCC = 'Trust Committee Chairman',
  ANESAC = 'Alumni/National Eagle Scout Association Chairman',
  CSC = 'Council Strategy Chairman',
  AP = 'Area President',
  AD = 'Area Director',
  AVPL = 'Area Vice President - At Large',
  AVPLL = 'Area Vice President - Learning for Life',
  AVPCOS = 'Area Vice President - Council Operations Support',
  APICC = 'Area Program Impact Committee Chairman',
  AMICC = 'Area Membership Impact Committee Chairman',
  AFICC = 'Area Finance Impact Committee Chairman',
  AMIC = 'Area Mission Impact Chairman',
  AVPOA = 'Area Vice President - Outdoor Adventures',
  ACATC = 'Area Camp Assessment Team Chairman',
  OASA = 'Order of the Arrow Section Advisor',
  AJC = 'Area Jamboree Chairman',
  AJA = 'Area Jamboree Ambassador',
  AVPM = 'Area Vice President - Marketing',
  MCA = 'Member Care',
  NES = 'National Executive Staff',
  LDL = 'Lion Den Leader',
  SUAC = 'SUAC',
  J2M = 'Jambo 2017 MBC',
  VCSR = 'Venturing College Sctr Reserve',
  PEPAA = 'Post - Explorer Post Associate Advisor',
  CO = 'Contact',
  ATP = 'Asst. Teacher/Parent',
  GC = 'Guidance Counselor',
  PIR = 'Post - Institutional Representative',
  LT = 'Lead Teacher',
  PCCH = 'Post Committee Chairman', // same as Post Committee Chair?
  PCM = 'Post Committee Member',
  SP = 'ScoutParent',
  L1YOSC = 'Leader of 11-Year-Old Scouts',
  SR = 'Scouter Reserve',
  CSR = 'College Scouter Reserve',
  PAA = 'Post Associate Advisor',
  TCDC = 'Tiger Cub Den Coordinator',
  DLC = 'Den Leader Coach',
  DM = 'Den Mother',
  IR = 'Institutional Representative',
  TCCO = 'Tiger Cub Coach',
  WDLC = 'Webelos Den Leader Coach',
  LLP = 'Learning for Life Presenter',
  CLLCC = 'Council Learning for Life Committee Chair',
  CLLCP = 'Council Learning for Life Committee Participant',
  DLLCC = 'District Learning for Life Committee Chair',
  DLLCP = 'District Learning for Life Committee Participant',
  CSTC = 'Council Service Team Chair',
  CSTCM = 'Council Service Team Chair Member',
  DSTC = 'District Service Team Chair',
  DSTM = 'District Service Team Member',
  UMC = 'Unit Membership Chair',
  LM = 'Lab Manager',
  ALM = 'Associate Lab Manager',
  OATA = 'Order of the Arrow Troop Advisor',
  //---------------------------------------------
}

export enum UnitRequiredPositions {
  ULCE = 'Unit Log Create/Edit',
  ILCE = 'Individual Log Create/Edit',
  LE = 'Leadership Edit',
  LER = 'Leadership Edit (restricted.)',
  IAM = 'Inactive Adult Members',
  IYM = 'Inactive Youth Members',
  DC = 'Den Create',
  DCA = 'Den Chief Add',
  DE = 'Den Edit',
  UE = 'Unit Edit',
  R = 'Reports',
}

export const PositionsAllowedToHaveCR: string[] = [
  Positions.CC,
  Positions.MC,
  Positions.NM,
  Positions.PT,
];

export const ProhibitedUnitLeadershipPositions: string[] = [
  Positions.CM,
  Positions.CR,
  Positions.CC,
  Positions.SM,
  Positions.CUR,
  Positions.VCA,
  Positions.SK,
  Positions.EPA,
];

export const ProhibitedFunctionalPositions: string[] = [
  Positions.US,
  Positions.SUS,
  Positions.DS,
];

export const InvalidPositions: string[] = [
  Positions.AWL,
  Positions.LG,
  Positions.TDL,
  Positions.WL,
  Positions.LAP,
  Positions.TCA,
  Positions.ACRUD,
  Positions.AAW,
  Positions.AAPR,
  Positions.AE,
  Positions.MBCL,
  Positions.TRE,
  Positions.SCRR,
  Positions.FCR,
  Positions.CE,
  Positions.CES,
  Positions.POC,
  Positions.CMSSG,
  Positions.MGCRUD,
  Positions.PE,
];

export const PositionsRestrictedByPermissions: string[] = [
  Positions.CR,
  Positions.CORD,
  Positions.CM,
  Positions.SM,
  Positions.SK,
  Positions.VCA,
  Positions.CC,
  Positions.PCC,
  Positions.EPA,
  Positions.AS,
  Positions.ES,
];

export const RestrictedSBPositions: string[] = [
  Positions.SM,
  Positions.ASM,
  Positions.OUA,
  Positions.CS,
  Positions.UT,
  Positions.UOAC,
  Positions.UAC,
  Positions.UC,
  Positions.UTC,
  Positions.CEC,
  Positions.CMC,
  Positions.YPC,
  Positions.VCA,
  Positions.USE,
  Positions.SPD,
  Positions.OG,
  Positions.MBC,
  Positions.CM,
  Positions.AC,
  Positions.DL,
  Positions.ADL,
  Positions.PT,
  Positions.WDL,
  Positions.WADL,
  Positions.TDL,
  Positions.TAP,
  Positions.VSC,
  Positions.AVC,
  Positions.VCAA,
  Positions.SK,
  Positions.MA,
  Positions.PC,
  Positions.L1YOS,
  Positions.CR,
  Positions.CCH,
  Positions.MC,
  Positions.EO,
  Positions.UREC,
  Positions.UCSR,
  Positions.USR,
  Positions.LCSFC,
  Positions.LSFC,
  Positions.UCO,
  Positions.DC,
  Positions.ADC,
  Positions.ACC,
  Positions.CCO,
  Positions.RC,
  Positions.RS,
  Positions.NC,
  Positions.NCSS,
  Positions.NCSC,
  Positions.ACO,
  Positions.RCO,
  Positions.VSHC,
  Positions.VSHS,
  Positions.DCM,
  Positions.DCH,
  Positions.DVC,
  Positions.FM,
  Positions.AL,
  Positions.CP,
  Positions.CVP,
  Positions.CT,
  Positions.CAT,
  Positions.CEBM,
  Positions.CAC,
  Positions.CCM,
  Positions.CML,
  Positions.NCH,
  Positions.NCO,
  Positions.DML,
  Positions.NAC,
  Positions.SAM,
  Positions.TA,
  Positions.SME,
  Positions.UPRC,
  Positions.UFC,
  Positions.UFRC,
  Positions.USC,
  Positions.LEC,
  Positions.RP,
  Positions.RD,
  Positions.SA,
  Positions.REVP,
  Positions.RVPCOS,
  Positions.RPICC,
  Positions.RMICC,
  Positions.RMICCH,
  Positions.RFICC,
  Positions.RVPOA,
  Positions.ROPCC,
  Positions.ROAC,
  Positions.RJC,
  Positions.RVPM,
  Positions.RVPLL,
  Positions.EC,
  Positions.RNCC,
  Positions.RMSCC,
  Positions.TCC,
  Positions.ANESAC,
  Positions.CSC,
  Positions.AP,
  Positions.AD,
  Positions.AVPL,
  Positions.AVPLL,
  Positions.AVPCOS,
  Positions.APICC,
  Positions.AMICC,
  Positions.AFICC,
  Positions.AMIC,
  Positions.AVPOA,
  Positions.ACATC,
  Positions.OASA,
  Positions.AJC,
  Positions.AJA,
  Positions.AVPM,
  Positions.MCA,
  Positions.NES,
  Positions.LDL,
  Positions.LAP,
  Positions.SUAC,
  Positions.J2M,
  Positions.VCSR,
  Positions.NM,
  Positions.PEPAA,
  Positions.CO,
  Positions.ATP,
  Positions.EPA,
  Positions.GC,
  Positions.PIR,
  Positions.LT,
  Positions.PCCH,
  Positions.PCM,
  Positions.SP,
  Positions.L1YOSC,
  Positions.SR,
  Positions.CSR,
  Positions.PAA,
  Positions.TCDC,
  Positions.DLC,
  Positions.DM,
  Positions.IR,
  Positions.TCCO,
  Positions.AWL,
  Positions.WDLC,
  Positions.K3D,
  Positions.LLP,
  Positions.CLLCC,
  Positions.CLLCP,
  Positions.DLLCC,
  Positions.DLLCP,
  Positions.CSTC,
  Positions.CSTCM,
  Positions.DSTC,
  Positions.DSTM,
  Positions.ES,
  Positions.AS,
  Positions.UMC,
  Positions.LM,
  Positions.ALM,
  Positions.OATA,
  Positions.CUR,
];

export const FeaturePermissionPositions = {
  [CelKey.ACTIVITY_CREATE]: {
    id: -1,
    name: 'Activity Approver/Creator/Remover/Editor',
  },
  [CelKey.ADVANCEMENT_AWARD]: { id: -2, name: 'Advancement Awarder' },
  [CelKey.ADVANCEMENT_APROVE]: { id: -3, name: 'Advancement Approver' },
  [CelKey.ADVANCEMENT_EDIT]: {
    id: -4,
    name: 'Advancement Editor (includes Youth Leadership)',
  },
  [CelKey.ADVANCEMENT_MBLIST]: { id: -5, name: 'MBC List' },
  [CelKey.ADVANCEMENT_SCOUT_EDITOR]: {
    id: -6,
    name: 'Scout Requirement Editor/Approver (NO SM)',
  },
  [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: {
    id: -7,
    name: 'Tenderfoot Requirement Editor/Approver (NO SM NO BOR)',
  },
  [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: {
    id: -8,
    name: 'Second Class Requirement Editor/Approver (NO SM NO BOR)',
  },
  [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: {
    id: -9,
    name: 'First Class Requirement Editor/Approver (NO SM NO BOR)',
  },
  [CelKey.CALENDAR_CREATE]: { id: -10, name: 'Calendar Editor' },
  [CelKey.SUB_CALENDAR_CREATE]: {
    id: -11,
    name: 'Calendar Editor by SubUnit',
  },
  [CelKey.FINANCE_POCREATE]: { id: -12, name: 'P.O. Creator/Editor' },
  [CelKey.MESSAGING_CREATE]: { id: -13, name: 'Create Messages' },
  [CelKey.MESSAGING_GROPU_CREATE]: {
    id: -14,
    name: 'Create/Delete/Edit Message Groups',
  },
  [CelKey.UNIT_PROFILE_EDIT]: { id: -15, name: 'Profile Editor' },

  /**The following don't exist and are not assignable */
  [CelKey.FINANCE_CREATE]: { id: -16, name: '' },
  [CelKey.FINANCE_INDIVCREATE]: { id: -17, name: '' },
  [CelKey.LEADERSHIP_EDIT]: { id: -18, name: '' },
  [CelKey.LEADERSHIP_EDIT_RESTRICTED]: { id: -19, name: '' },
  [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { id: -20, name: '' },
  [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { id: -21, name: '' },
  [CelKey.SUBUNIT_CREATE]: { id: -22, name: '' },
  [CelKey.SUBUNIT_DENCHIEF_ADD]: { id: -23, name: '' },
  [CelKey.SUBUNIT_EDIT]: { id: -24, name: '' },
  [CelKey.UNIT_EDIT]: { id: -25, name: '' },
  [CelKey.UNIT_REPORTS]: { id: -26, name: '' },
};

/**
 * Display-only permission position mappings.
 *
 * This object extends `FeaturePermissionPositions` with placeholder entries
 * for permissions that do not have a real backend position.
 *
 */
export const DisplayPermissionPositions: Record<
  string,
  { id: number; name: string }
> = {
  ...FeaturePermissionPositions,
  [CelKey.FINANCE_CREATE]: { id: -16, name: UnitRequiredPositions.ULCE },
  [CelKey.FINANCE_INDIVCREATE]: { id: -17, name: UnitRequiredPositions.ILCE },
  [CelKey.LEADERSHIP_EDIT]: { id: -18, name: UnitRequiredPositions.LE },
  [CelKey.LEADERSHIP_EDIT_RESTRICTED]: {
    id: -19,
    name: UnitRequiredPositions.LER,
  },
  [CelKey.MEMBERSHIP_INACTIVE_ADULT]: {
    id: -20,
    name: UnitRequiredPositions.IAM,
  },
  [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: {
    id: -21,
    name: UnitRequiredPositions.IYM,
  },
  [CelKey.SUBUNIT_CREATE]: { id: -22, name: UnitRequiredPositions.DE },
  [CelKey.SUBUNIT_DENCHIEF_ADD]: { id: -23, name: UnitRequiredPositions.DCA },
  [CelKey.SUBUNIT_EDIT]: { id: -24, name: UnitRequiredPositions.DE },
  [CelKey.UNIT_EDIT]: { id: -25, name: UnitRequiredPositions.UE },
  [CelKey.UNIT_REPORTS]: { id: -26, name: UnitRequiredPositions.R },
};

export const CategoryPanels = [
  PanelTitle.ACTIVITY,
  PanelTitle.ADVANCEMENT,
  PanelTitle.ADVANCEMENT_YOUTH,
  PanelTitle.CALENDAR,
  PanelTitle.CALENDAR_YOUTH,
  PanelTitle.FINANCE,
  PanelTitle.LEADERSHIP,
  PanelTitle.MEMBERSHIP,
  PanelTitle.MESSAGING,
  PanelTitle.MESSAGING_YOUTH,
  PanelTitle.UNIT,
];

export type PermissionScope = 'unit' | 'subUnit';

export interface PermissionCategory {
  key: string;
  title: string;
  positions: (Positions | UnitRequiredPositions | string)[];
}

export const PERMISSION_CATEGORIES: PermissionCategory[] = [
  {
    key: PanelTitle.ACTIVITY,
    title: 'Activity',
    positions: [Positions.ACRUD, `${Positions.ACRUD} (sub-unit only)`],
  },
  {
    key: PanelTitle.ADVANCEMENT,
    title: 'Advancement',
    positions: [
      Positions.AE,
      Positions.AAW,
      Positions.AAPR,
      Positions.MBCL,
      Positions.AE,
      Positions.TRE,
      Positions.SCRR,
      Positions.FCR,
    ],
  },
  {
    key: PanelTitle.CALENDAR,
    title: 'Calendar',
    positions: [Positions.CE, Positions.CES],
  },
  {
    key: PanelTitle.FINANCE,
    title: 'Finance',
    positions: [
      UnitRequiredPositions.ILCE,
      UnitRequiredPositions.ULCE,
      Positions.POC,
    ],
  },
  {
    key: PanelTitle.LEADERSHIP,
    title: 'Leadership',
    positions: [UnitRequiredPositions.LE, UnitRequiredPositions.LER],
  },
  {
    key: PanelTitle.MEMBERSHIP,
    title: 'Membership',
    positions: [UnitRequiredPositions.IAM, UnitRequiredPositions.IYM],
  },
  {
    key: PanelTitle.MESSAGING,
    title: 'Messaging',
    positions: [Positions.CMSSG, Positions.MGCRUD],
  },
  {
    key: PanelTitle.UNIT,
    title: 'Unit',
    positions: [
      Positions.PE,
      UnitRequiredPositions.UE,
      UnitRequiredPositions.R,
      UnitRequiredPositions.DC,
      UnitRequiredPositions.DE,
      UnitRequiredPositions.DCA,
    ],
  },
];

export const PERMISSIONS_GUIDE_REPORT_URL =
  'https://filestore.scouting.org/filestore/scoutbook/Report-Permission-Access.pdf';
